import { ErrorFallback } from '@euler/components/error';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const ErrorScreen = wrapNavigatorScreen(
  () => {
    return (
      <ErrorFallback
        error={new Error('The resource does not exist')}
        componentStack={null as any}
        eventId={null}
        resetError={() => null}
      />
    );
  },
  { headerShown: false },
);
